import { StructureCanvasHelper } from '../canvas';
import type { ReferenceChip } from '../layout';
import {
  connectorLabelStyle,
  highlightedConnectorLabelStyle,
} from './connector-label-style';

interface ReferenceChipButtonProps {
  chip: Readonly<ReferenceChip>;
  isHighlighted: boolean;
  onSelect: (entityId: number) => void;
  onReveal: (chip: Readonly<ReferenceChip>) => void;
}

// The layer under the cards ignores the pointer, so the chip takes it back.
const ReferenceChipButton = ({
  chip,
  isHighlighted,
  onSelect,
  onReveal,
}: ReferenceChipButtonProps) => (
  <button
    type="button"
    title={chip.text}
    className={`nodrag nopan ${StructureCanvasHelper.CHIP_CLASS}`}
    onClick={() => onSelect(chip.counterpartId)}
    onFocus={(event) => {
      if (event.currentTarget.matches(':focus-visible')) onReveal(chip);
    }}
    style={{
      ...(isHighlighted ? highlightedConnectorLabelStyle : connectorLabelStyle),
      left: chip.x,
      top: chip.y,
      width: chip.width,
      height: chip.height,
      cursor: 'pointer',
      pointerEvents: 'auto',
    }}
  >
    {chip.text}
  </button>
);

export { ReferenceChipButton };
